import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

/**
 * 全局应用 Store
 * 
 * 管理: Feature Flag、侧边栏折叠、全局加载、面包屑
 */
export const useAppStore = defineStore('app', () => {
  // ===== Feature Flags =====
  // 文件01-PRODUCT-BOUNDARY: 当前阶段排除支付/退款/电子合同/微信小程序
  const features = ref({
    PAYMENT_ENABLED: false,      // K7: 真实支付G3
    REFUND_ENABLED: false,       // 退款G3
    ECONTRACT_ENABLED: false,    // 电子合同G3
    MINIAPP_ENABLED: false,      // 微信小程序暂不实现
    EXPORT_ENABLED: true,        // 数据导出
    AUDIT_ENABLED: true,         // 审计日志
    PAYROLL_ENABLED: true,       // 薪资管理
    INVENTORY_ENABLED: true,     // 物料管理(K12: 独立域)
    PLUGIN_ENABLED: true,        // 插件能力(K14)
    MOCK_MODE: true,             // Mock数据模式
  })

  // ===== UI State =====
  const sidebarCollapsed = ref(false)
  const globalLoading = ref(false)
  const breadcrumbs = ref<{ title: string; path?: string }[]>([])

  // ===== Computed =====
  const isMockMode = computed(() => features.value.MOCK_MODE)

  // ===== Actions =====
  function toggleSidebar() {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }

  function setBreadcrumbs(crumbs: { title: string; path?: string }[]) {
    breadcrumbs.value = crumbs
  }

  function setGlobalLoading(loading: boolean) {
    globalLoading.value = loading
  }

  function isFeatureEnabled(key: keyof typeof features.value): boolean {
    return features.value[key]
  }

  return {
    features,
    sidebarCollapsed,
    globalLoading,
    breadcrumbs,
    isMockMode,
    toggleSidebar,
    setBreadcrumbs,
    setGlobalLoading,
    isFeatureEnabled,
  }
})
